import { ContentLibraryPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/ContentLibraryMenu/ContentLibraryPopout/ContentLibraryPopout";

export { ContentLibraryPopout };
